<template>
  <div id="viewHome">
    <b-container fluid id="main-container">
      <Header />
    </b-container>
      <div class="home-msg">
        <p>
          Example Dota ID: 131375636
        </p>
        <p>
          <a href="https://bitbucket.org/renzivan15/dota-2-web-app-using-vue.js/src/master/" target="_blank">Source Code Repository</a>
        </p>
      </div>
  </div>
</template>

<script>
import Header from '@/components/Header'

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
.home-msg {
  position: absolute;
  top: 30%;
  width: 100%;
  text-align: center;
  a {
    color: #fff;
  }
}
</style>
